import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './UserSubstitution.html?raw';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import "../../UI/HintBox/HintBox";
import GenericDialog from '../../UI/GenericDialog/GenericDialog';
import SearchSelect from '../../UI/SearchSelect/SearchSelect';
import "../../UI/SearchSelect/SearchSelect";


interface SubstituteData {
    displayname: string;
    webuserID: string;
    employeeID: string;
    webuserName: string;
    employeeName: string;
}

interface RequestData {
    newEmployeeId: string,
    newUserDisplayname: string,
    newUserId: string,
    newUserName: string
}

type displaymode = "default" | "compactDlg";
class UserSubstitutionForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private selectedSubstituteInfoContainer: HTMLElement;
    private interactionContainer: HTMLElement;
    private actualWebuserLabel: HTMLElement;
    private selectedSubstituteLabel: HTMLElement;
    private txtSubstitutionDescription: HTMLElement;
    private btnStartSubstitution: HTMLElement;

    //private inputSubstitute: HintBox;
    private inputSubstituteSelect: MdsLax<InstanceType<typeof SearchSelect>>;

    private _isInteractive: boolean = false;

    private _displayMode: displaymode = "default";

    private _currentSubstitute: SubstituteData = null;

    private confirmationDlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private _isDojoStartupDone: boolean = false;
    private _customCallback: Function = null;

    setupAsDialog(callback?: Function) {
        let dlg = new GenericDialog();
        dlg.enableContentOverflow(true);

        dlg.show(this, "SubstituteForm__Title", null, null, "close");

        if (callback) this._customCallback = callback;

        this.startup();

        //this.inputSubstitute.focus();
        if (!window.sessionInfo.isSubstitutionActive()) {
            this.inputSubstituteSelect.focus();
        }
    }

    private showConfirmationDlg(substituteEntity: SubstituteData) {
        let dialog = new GenericDialog();
        this.confirmationDlg = dialog;

        let header = this.translate("SubstituteForm__SelectSubstituteHeading");
        let message = this.translate("SubstituteForm__SelectSubstituteMessage");

        let userDisplayname = window.sessionInfo.getUserDisplayName();

        if (substituteEntity == null) {
            header = this.translate("SubstituteForm__RemoveSubstituteHeading");
            message = this.translate("SubstituteForm__RemoveSubstituteMessage");

        } else {
            userDisplayname = substituteEntity.displayname;
        }

        message = this.stringFormat(message, userDisplayname);

        dialog.setSize("smaller");


        dialog.keepOpen = true;
        dialog.closeOnEnter = true;
        dialog.closeOnEscape = true;
        dialog.show(message, header, null, "fas fa-user fa-mds-user-substitution", "okcancel", lang.hitch(this, this._ConfirmationDlgResult, substituteEntity));
    }

    private _ConfirmationDlgResult(substituteEntity: SubstituteData, result: number) {
        // gewählte Vertretung gehört jetzt auf die Session usw usw ...

        if (result == 1) {
            if (substituteEntity == null) {
                this._setSubstitution(null, null, null, null);
            } else {
                this._setSubstitution(substituteEntity.employeeID, substituteEntity.webuserID, substituteEntity.webuserName, substituteEntity.employeeName);
            }

        } else {
            //this.inputSubstitute.setValue(null, true);
            this.inputSubstituteSelect.setValue(null, true);
            this.confirmationDlg.close(-1, true);
        }
    }

    /**
     * Die aktuelle Session in den Vertretermodus setzen (oder Vertretung beenden, wenn newUserId == null)
     * Hinweis: Feature System/enableUserSubstitution muss vorhanden sein. Es darf keine Vertretung aktiv sein, wenn eine neue gestartet werden soll.
     * @param newUserId
     * @param callbackSuccess
     * @param callbackError
     * @returns
     */
    setSubstitution(newUserId: string, callbackSuccess: Function, callbackError: Function) {
        if (!this.hasFeature("system/enableUserSubstitution")) {
            console.warn(this.id + ": cannot set substitute user - feature not available!");
            return;
        }

        // eher ein Sicherheitsmechanismus als sonst was, der Controller in der Webbase wird ohnehin checken, wenn die Session schon vertreten ist
        // und würde die Vertretung einfach ersetzen. Lassen wir aber jetzt trotzdem vorerst nicht zu, User soll die Vertretung zuerst beenden.
        if (newUserId != null && window.sessionInfo.isSubstitutionActive()) {
            console.warn(this.id + ": cannot set substitute user when already substituting!");
            return;
        }

        this._setSubstitution(null, newUserId, null, null, callbackSuccess, callbackError);
    }

    private _setSubstitution(newEmployeeId: string, newUserId: string, newUsername: string, newDispname: string, successCallback?: Function, errorCallback?: Function) {

        //this.inputSubstitute.setReadonly(true);
        this.inputSubstituteSelect.setReadonly(true);
        

        if (this.confirmationDlg) {
            this.confirmationDlg.disableAllButtons(true);
        }

        let url = window.appRoot + "Session/SetSubstitute";
        
        let data: RequestData = {
            newEmployeeId: newEmployeeId,
            newUserDisplayname: newDispname,
            newUserId: newUserId,
            newUserName: newUsername
        }

        if (typeof (successCallback) != "function") {
            successCallback = lang.hitch(this, this._setSubstituteEmployeeResponse);
        }
        if (typeof (errorCallback) != "function") {
            errorCallback = lang.hitch(this, this._setSubstituteEmployeeError);
        }

        this.RequestManager.post(
            url,
            data,
            successCallback as any,
            errorCallback as any,
            false // sync
        );
    }

    private _setSubstituteEmployeeResponse(response) {
        //this.inputSubstitute.set("value", null, true);
        //this.inputSubstitute.setValue(null, true, true);

        //this.inputSubstitute.setReadonly(true);
        this.inputSubstituteSelect.setReadonly(true);

        if (this.confirmationDlg) {
            this.confirmationDlg.close(-1, true);
        }

        this.showToast({
            title: this.translate("SubstituteForm__SubstitutionSuccess"),
            iconClass: toasterIcons.confirmCheck,
            timeout: "permanent",
            showClose: false
        });

        if (typeof (this._customCallback) == "function") this._customCallback();

        setTimeout(lang.hitch(location, "reload"), 500);        
    }

    private _setSubstituteEmployeeError(error: more.requestErrorMessage) {
        if (this.confirmationDlg) this.confirmationDlg.close(-1, true);

        let message = this.stringFormat(this.translate("SubstituteForm__SubstitutionError_Message"), error.Message);

        let dlg = new GenericDialog();

        dlg.show(message,
            this.translate("SubstituteForm__SubstitutionError_Heading"),
            null,
            toasterIcons.error,
            "close");

        //this.inputSubstitute.setReadonly(window.sessionInfo.isSubstitutionActive());
        this.inputSubstituteSelect.setReadonly(window.sessionInfo.isSubstitutionActive());
    }
    

    private checkForExistingSession(): void {

        if (window.sessionInfo) {
            if (window.sessionInfo.isSessionOpen()) {
                this._onSessionData(window.sessionInfo.sessionData);
            }
        }

        this.addSubscription("/Session/NewSession", lang.hitch(this, this._onNewSession));
    }

    private _setDisplayStyle(mode: displaymode = "default") {

    }
   
    private _setStyles() {

        let isSession = false;
        let userName = this.getCurrentUserName();
        let userDisplay = this.getCurrentUserDisplayName();
        let sessionData = null;
        let employeeId = this.getCurrentEmployeeId();

        let actualUserName = userName;
        let actualUserDisplay = userDisplay;
        let actualEmployeeId = employeeId;


        if (!window.sessionInfo) {

        } else {
            isSession = window.sessionInfo.isSessionOpen();
            userName = window.sessionInfo.getUserName();
            userDisplay = window.sessionInfo.getUserDisplayName();
            sessionData = window.sessionInfo.sessionData;
            employeeId = window.sessionInfo.getCurrentEmployeeId();

            actualUserName = window.sessionInfo.getUserName(true);
            actualUserDisplay = window.sessionInfo.getUserDisplayName(true);
            actualEmployeeId = window.sessionInfo.getCurrentEmployeeId(true);

        }
        
        this.hideNode(this.selectedSubstituteInfoContainer);
        this.hideNode(this.interactionContainer);

        if (isSession === true) {
            this.hideNode(this.domNode, false);

            this.UiModder.domAttr.set(this.actualWebuserLabel, "innerHTML", actualUserDisplay);

            if (window.sessionInfo.isSubstitutionActive()) {

                this.hideNode(this.selectedSubstituteInfoContainer, false);

                this.UiModder.domAttr.set(this.selectedSubstituteLabel, "innerHTML", userDisplay);
            } else {
                if (this._isInteractive === true) {
                    this.hideNode(this.interactionContainer, false);
                }
            }
                

        } else {
            this.hideNode(this.domNode);
        }
    }

    private _onSessionLoading(isLoading: boolean) {

    }

    private _onSessionData(newData: SessionData) {
        this._setStyles();

        let substituteTargets = window.sessionInfo.getCachedSubstitutes() as Array<SubstituteData>;

        this._onSubstitutionsAvailable(substituteTargets);        
    }

    private _onSubstitutionsAvailable(data: Array<SubstituteData>) {
        this.inputSubstituteSelect.setSelectionListLEGACY(data, null, "displayname", "webuserID");
    }

    private _onNewSession() {
        this._setStyles();

    }
    private _onOpenSession(data: SessionData) {

    }
    private _onCloseSession() {

    }

    private _onChangeSubstitute(value: SubstituteData) {
        //this.disableNode(this.btnStartSubstitution, !value);
        //let selectedSubstitute = this.inputSubstitute.getValue("entity");
        let selectedSubstitute = this.inputSubstituteSelect.getValue(true);

        if (!!selectedSubstitute) this.showConfirmationDlg(selectedSubstitute);
    }

    private _onClick_RemoveSubstitute(evt: MouseEvent) {
        this.showConfirmationDlg(null);
    }

    private _onClick_StartSubstitution(evt) {
        //let value = this.inputSubstitute.getValue("entity");
        let value = this.inputSubstituteSelect.getValue(true);

        //if (!!value) this._setSubstitution(value);
        if (!!value) this.showConfirmationDlg(value);
    }

   
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._isInteractive = this.hasFeature("System/enableUserSubstitution");

        this.UiModder.domAttr.set(this.txtSubstitutionDescription, "innerHTML", this.translate("SubstituteForm__InfoText"));
        this.hideNode(this.txtSubstitutionDescription, false);

        this.checkForExistingSession();

        this.addSubscription("/Session/Loading", lang.hitch(this, this._onSessionLoading));
        this.addSubscription("/Session/CurrentSessionData", lang.hitch(this, this._onSessionData));
        this.addSubscription("/Session/Open", lang.hitch(this, this._onOpenSession));
        this.addSubscription("/Session/Close", lang.hitch(this, this._onCloseSession));
        this.addSubscription("/Session/SubstutitionsAvailable", lang.hitch(this, this._onSubstitutionsAvailable));        
       
    }

    startup(): void {

        if (this._isDojoStartupDone) return;
        super.startup.apply(this, arguments as any);

        this._isDojoStartupDone = true;
    }
}

export default mdsWidget(UserSubstitutionForm);